import React, {Component} from 'react';
import {RegistrationStore} from '../registration.store';

export default class IframeLogin extends Component {

  constructor(props) {
    super(props);
    var temp_state = RegistrationStore.getState();
    this.state = {};
    if (temp_state.signupRespData) {
      this.state = {
        status_token: temp_state.signupRespData.token[1][1],
        idp_id      : temp_state.signupRespData.token[1][0],
        user_id     : temp_state.signupRespData.patient.id,
      };
      this.state.url = `/set_cookie?user_id=${this.state.user_id}&idp_id=${this.state.idp_id}&status_token=${this.state.status_token}`;
    }
  }


  render() {
    return <div>
      <form target="hidden_iframe" id="cookies_form" action={this.state.url} method="post"></form>
      <iframe id="login_iframe" name="hidden_iframe" src="#"></iframe>
    </div>;
  }
}


// WEBPACK FOOTER //
// ./registration-react/components/iframe_login.js